<script setup lang="ts">
const pagination = usePagination()

// 페이지 숫자 클릭
const handlePageClick = (page: number) => {
  pagination.setPage(page)
}

// 이전 페이지로 이동
const handlePrevClick = () => {
  if (pagination.state.value.currentPage > 1) {
    pagination.prev()
  }
}

// 다음 페이지로 이동
const handleNextClick = () => {
  if (pagination.state.value.currentPage < pagination.state.value.totalPage) {
    pagination.next()
  }
}

// 이전/다음 버튼 비활성화 상태 계산
const isPrevDisabled = computed(() => pagination.state.value.currentPage === 1)
const isNextDisabled = computed(
  () => pagination.state.value.currentPage === pagination.state.value.totalPage,
)
</script>

<template>
  <div class="pagingArea pagingAreaFix">
    <ul>
      <li>
        <a
          class="btnPrev"
          :class="{ disabled: isPrevDisabled }"
          @click="handlePrevClick"
        >
          이전
        </a>
      </li>
      <li v-for="page in pagination.state.value.pageRange" :key="page">
        <template v-if="page === pagination.state.value.currentPage">
          <strong>{{ page }}</strong>
        </template>
        <template v-else>
          <a @click="handlePageClick(page)">{{ page }}</a>
        </template>
      </li>
      <li>
        <a
          class="btnNext"
          :class="{ disabled: isNextDisabled }"
          @click="handleNextClick"
        >
          다음
        </a>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
